<template>
    <div class="content">
        <h3>Philosophie</h3>

        <p>
        Bei der Herdenschutz UG dreht sich alles um kamerabasierte Herdenüberwachung. Die
        Einsatzgebiete sind dabei vielfältig. Wir haben unser Portfolio genau auf den Bedarf unserer
        Kunden angepasst.
        </p>

        <p>
        Doch wir werfen nicht irgendeine weitere Überwachungskamera auf den Markt. Im Fokus steht
        nicht die Überwachungskamera selbst, sondern die Dienstleistung. Durch unsere selbst
        entwickelte Software haben wir es geschafft, die Live-Bilder unserer Kunden zu bündeln und
        unseren geschulten Mitarbeitern zur nächtlichen Überwachung vorzulegen.
        </p>

        <p>
        Hatten Sie schon einmal ein Projekt, welches Sie so begeistert hat dass es keinen Unterschied
        mehr zwischen Arbeit und Freizeit gab? - Dann verstehen Sie, wie wir uns fühlen!
        </p>

        <p>
        Wir haben das Produkt mit Leidenschaft und Hingabe entwickelt. Da wir selbst - als Züchter - auf
        dem aktuellen Markt keine zufriedenstellende Lösung zur Geburtenkontrolle und Herdenüberwachung gefunden
        haben, welche uns zu 100% überzeugt hat, haben wir beschlossen die Innovation selbst
        voranzutreiben und sind davon überzeugt, dass wir auch Sie für unsere Produkte begeistern
        können.
        </p>

        <p>
            <span id="signature_cl"><img src="../assets/signature_cl.png" alt="Unterschrift Christian Lohmeyer">Christian Lohmeyer</span>
            <span id="signature_db"><img src="../assets/signature_db.png" alt="Unterschrift Davis Busche">Davis Busche</span>
        </p>

        <div class="swiper-container" id="philosophy_persons_swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(person, index) in persons" :key="index">
                    <img :data-src="person.image" class="swiper-lazy" :alt="'Portrait ' + person.name">
                    <span class="name" v-html="person.name"></span>
                    <span class="role" v-html="person.role"></span>
                </div>
            </div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </div>

        <img class="bg" src="../assets/logo_large.png" alt="Logo Herdenschutz">
    </div>
</template>


<style scoped>
img.bg {
    position: absolute;
    width: 28em;
    right: 8em;
    top: 8em;
    z-index: 0;
}

p {
    z-index: 1;
    position: relative;
}

#signature_cl,
#signature_db {
    font-size: .5em;
    margin-top: 6em;
    display: inline-block;
    position: relative;
}

#signature_cl {
    margin-right: 28em;
}

#signature_cl img,
#signature_db img {
    position: absolute;
    left: 0;
    bottom: 1.2em;
    height: 5em;
}

#signature_db img {
    right: 0;
    left: auto;
}

.swiper-container {
    padding: 0 1em;
    margin-top: 8em;
}

.swiper-button-prev {
    left: 0;
    color: #000;
    font-weight: bold;
}

.swiper-button-next {
    left: auto;
    right: 0;
    color: #000;
    font-weight: bold;
}

.swiper-slide {
    text-align: center;
}

.swiper-slide img {
    width: 80%;
}

.swiper-slide span.name {
    display: block;
    font-size: 1.5em;
}

.swiper-slide span.role {
    display: block;
    margin-top: .5em;
}

@media only screen and (max-width: 1920px) {
    img.bg {
        width: 28%;
    }
}

@media only screen and (max-width: 760px) {
    img.bg {
        opacity: .1;
        width: 80%;
        left: 50%;
        right: auto;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>


<script>
export default {
    data: () => {
        return {
            persons: [
                {
                    image: 'persons/Christian Lohmeyer.png',
                    name: 'Christian Lohmeyer',
                    role: 'Geschäftsführung<br>M.Sc. Agrar<br>Landwirt'
                },
                {
                    image: 'persons/Davis Busche.png',
                    name: 'Davis Busche',
                    role: 'Geschäftsführung<br>IT-Management'
                },
                {
                    image: 'persons/Eileen Becker.png',
                    name: 'Eileen Becker',
                    role: 'Überwachung<br>Tierarzt'
                },
                {
                    image: 'persons/Eva Maria Weber.png',
                    name: 'Eva Maria Weber',
                    role: 'Überwachung<br>Tierarzt'
                },
                /*{
                    image: 'persons/Emma Schrempf.png',
                    name: 'Emma Schrempf',
                    role: 'Überwachung<br>Tiermedizinstudentin'
                },
                {
                    image: 'persons/Eva Knebel.png',
                    name: 'Eva Knebel',
                    role: 'Überwachung<br>Tiermedizinstudentin'
                },
                {
                    image: 'persons/Hannah Michel.png',
                    name: 'Hannah Michel',
                    role: 'Überwachung<br>Tiermedizinstudentin'
                },*/
                {
                    image: 'persons/Jana Lehnen.png',
                    name: 'Jana Lehnen',
                    role: 'Überwachung<br>Tiermedizinstudentin'
                },
                /*{
                    image: 'persons/Lena Kehlert.png',
                    name: 'Lena Kehlert',
                    role: 'Überwachung<br>Tiermedizinstudentin'
                }*/
            ]
        }
    },
    mounted: function(){
        new window.Swiper ('#philosophy_persons_swiper', {
            slidesPerView: 2,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                /*
                760: {
                    slidesPerView: 2
                },
                */
                1100: {
                    slidesPerView: 4
                }
            },
            lazy: {
                loadPrevNext: true
            }
        });
    }
}
</script>
